/**
 * Created by fd on 2021-09-21 (10:00).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/ranking-screen.html";
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

const log = require("Sources/utils/logger")();

require("Styles/components/ranking-screen.scss");

class RankingScreen extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.platform = options.platform || "student";
        this.hasAWinner = false;
        this.path = "ranking";
        this.team = options.team;
        this.teams = options.teams;
        this.roundOverview = options.roundOverview;
        this.roundIndex = options.roundIndex;

        this.factCount = 3;
        this.factIndex = Math.floor(Math.random() * 3);

        setInterval(() =>
        {
            this.showFact();
        }, 1 * 60 * 1000);
    }

    updateTeamList(teamList)
    {
        this.teams = teamList;

        if (!this.hasRendered)
        {
            this.render();
        }

        this.update();
    }

    render()
    {
        super.render();
        this._setUpEventListeners();

        this.update();

        this.onRender();

        this.showFact();
    }

    update()
    {
        let winnerContainer = this.$element.find("#ranking-winner-container");

        winnerContainer.hide();
        $("#home-button-container").hide();

        this.renderRankingTable();

        if (this.hasAWinner)
        {
            winnerContainer.show();
        }

        if (this.hasAWinner && this.platform === "student")
        {
            // $("#home-button-container").show();
        }
    }

    show(darkMode)
    {
        $("#btn-next-phase").prop("disabled", "disabled");

        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.update();
        }
    }

    hide()
    {
        if (utils.isNotNull(this.$container) && this.$container.length)
        {
            this.$container.hide();
        }
    }

    renderRankingTable()
    {
        let container = this.$element.find(".ranking-table");
        let base = this.$element.find("#ranking-cell-base");

        container.find(".ranking-cell").remove();

        log.info("RANKING SCREEN UPDATE");
        log.info(this.teams);
        log.info(this.team);

        let sortedTeams = [];
        let round = -1;
        let allInSameRound = true;

        if (this.team && this.team.currentRound)
        {
            round = this.team.currentRound;
        }

        for (let i = 0; i < this.teams.length; i++)
        {
            let team = this.teams[i];
            let teamData = this.getCommonDataForTeam(team);
            let roundScore = this.getCurrentRoundScore(teamData);

            if (utils.isNotNull(roundScore))
            {
                if (round === -1)
                {
                    round = roundScore.round;
                }
                else if (round !== roundScore.round)
                {
                    allInSameRound = false;
                }
            }
            else
            {
                allInSameRound = false;
            }
        }

        if (allInSameRound || this.platform === "teacher")
        {
            this.$element.find("#ranking-waiting-container").hide();
        }
        else
        {
            this.$element.find("#ranking-waiting-container").show();
        }


        this.hasAWinner = allInSameRound && round === 11;

        // gather the teamnames, VP's and credits
        for (let i = 0; i < this.teams.length; i++)
        {
            let team = this.teams[i];
            let teamData = this.getCommonDataForTeam(team);
            let roundScore = this.getCurrentRoundScore(teamData);

            if (utils.isNotNull(roundScore))
            {
                let tmpPoints = roundScore.endPoints;
                let tmpCredits = roundScore.endCredits;

                let ratio = Math.floor(tmpCredits / 5);
                let pointsFromCredits = ratio;
                let remainingCredits = tmpCredits - (ratio * 5);

                let points = tmpPoints + pointsFromCredits;

                let sortedTeam = {
                    teamName: team,
                    tmpPoints: tmpPoints,
                    tmpCredits: tmpCredits,
                    points: points,
                    credits: remainingCredits,
                    currentRound: roundScore.round
                };

                sortedTeams.push(sortedTeam);
            }
        }

        if (__DEVELOPMENT__)
        {
            for (let i = sortedTeams.length; i < 35; ++i)
            {
                sortedTeams.push({
                    teamName: "__DEV-TEAM__",
                    tmpPoints: 0,
                    tmpCredits: 0,
                    points: 0,
                    credits: 0,
                    currentRound: round
                });
            }
        }

        sortedTeams.sort((a, b) =>
        {
            if (a.currentRound !== b.currentRound)
            {
                return b.currentRound - a.currentRound;
            }

            if (a.points < b.points)
            {
                return 1;
            }
            else if (a.points > b.points)
            {
                return -1;
            }

            if (a.credits < b.credits)
            {
                return 1;
            }
            else if (a.credits > b.credits)
            {
                return -1;
            }

            return 0;
        });

        log.info(sortedTeams);

        for (let i = 0; i < sortedTeams.length; i++)
        {
            let team = sortedTeams[i];
            let clone = base.clone();

            clone.removeAttr("id");

            if (team === this.team)
            {
                clone.addClass("ranking-cell-own-team");
            }

            let teamLabel = clone.find(".ranking-cell-name");
            let rankLabel = clone.find(".ranking-cell-icon > .ranking-label-container");
            let rankTrophy = clone.find(".ranking-cell-icon > img");
            let rankLoading = clone.find(".ranking-cell-icon > i");

            teamLabel.text(team.teamName);

            rankLabel.hide();
            rankTrophy.hide();
            rankLoading.hide();

            if (this.hasAWinner && i === 0)
            {
                rankTrophy.show();
            }
            else if (team.currentRound !== round)
            {
                rankLoading.show();
            }
            else
            {
                rankLabel.show();
                rankLabel.find("label").text(i + 1);
            }

            clone.find(".ranking-cell-resource").hide();
            clone.find(".ranking-cell-round").hide();

            if (team.currentRound !== round)
            {
                // clone.addClass("not-in-same-round");
                clone.find(".ranking-cell-round").show();
                clone.find(".ranking-cell-round .current-round").text(team.currentRound + 1 + 1); // First because of null based, second because last known round is the finished round
            }
            else
            {
                clone.find(".ranking-cell-resource").show();
                clone.find(".ranking-coins-label").text(team.tmpCredits);
                clone.find(".ranking-vp-label").text(team.tmpPoints).data("real-value", team.points);
            }

            container.append(clone);
        }

        clearTimeout(this.animationId);

        if (this.hasAWinner)
        {
            this.animationId = setTimeout(function()
            {
                let cellList = container.find(".ranking-cell");

                for (let i = 0; i < cellList.length; ++i)
                {
                    let cell = $(cellList[i]);

                    updatePointsAndVPs(cell);
                }

            }, 2000);
        }

        function updatePointsAndVPs(cell)
        {
            cell.addClass("updating");

            setTimeout(function()
            {
                let coinsLabel = cell.find(".ranking-coins-label");
                let pointsLabel = cell.find(".ranking-vp-label");

                let currentCoins = parseInt(coinsLabel.text());
                let currentPoints = parseInt(pointsLabel.text());

                let points = pointsLabel.data("real-value");


                cell.removeClass("updating");

                if (currentPoints < points)
                {
                    coinsLabel.text(currentCoins - 5);
                    pointsLabel.text(currentPoints + 1);

                    updatePointsAndVPs(cell);
                }

            }, 100);
        }
    }

    getCurrentRoundScore(teamData)
    {
        if (utils.isNull(teamData) || utils.isNull(teamData.roundScores)) return null;

        let roundScore = null;

        for (let j = teamData.roundScores.length - 1; j >= 0; j--)
        {
            if ((utils.isNull(this.roundIndex) || teamData.roundScores[j].round === this.roundIndex) && teamData.state.currentRound >= teamData.roundScores[j].round)
            {
                roundScore = teamData.roundScores[j];
                break;
            }
        }

        return roundScore;
    }

    _setUpEventListeners()
    {

    }

    getCommonDataForTeam(teamName)
    {
        if (utils.isNull(this.roundOverview) || utils.isNull(this.roundOverview.commonTeamData)) return null;

        for (let i = 0; i < this.roundOverview.commonTeamData.length; i++)
        {
            let teamData = this.roundOverview.commonTeamData[i];

            if (teamData.teamName === teamName)
            {
                return teamData;
            }
        }

        return null;
    }

    showFact()
    {
        ++this.factIndex;

        let index = this.factIndex % this.factCount + 1;

        let factTitle = LanguageManager.getValueForKey(`serious_game.business_model.loading.fact.${index}.title`);
        let factDescription = LanguageManager.getValueForKey(`serious_game.business_model.loading.fact.${index}.description`);

        this.$element.find(".current-fact-title").html(factTitle);
        this.$element.find(".current-fact-description").html(factDescription);
    }
}

module.exports = RankingScreen;



// WEBPACK FOOTER //
// ./app/js/components/game/components/ranking-screen.js